import constants from '~/utils/constants';
import type {
    MapSettingsState,
    PerTabMapSettings,
    PerTabMapSettingsState
} from './types';

export const defaultPerTabMapSettings: PerTabMapSettings = {
    isClusteringEquipment: false,
    isClusteringStops: false,
    isClusteringUnassignedTasks: false,
    isZonePolygonsEditMode: false,
    showDriverActualLines: false,
    showDriverLines: false,
    showDriverName: false,
    showEquipmentMarker: false,
    showLiveRoutesLabel: false,
    showLiveRoutesPopup: false,
    showRouteLabel: false,
    showRoutePolygons: false,
    showRoutePopup: false,
    showHqDepot: true,
    showDepotLabels: false,
    showSatelliteDepots: true,
    showStopLabel: false,
    showStopNumber: false,
    showStopPopup: false,
    showUnassignedTasks: false,
    showVehicleEid: false,
    showZonePolygons: false
};

export const perTabMapSettings: PerTabMapSettingsState = {
    [constants.mapRouteModes.PLAN]: {
        ...defaultPerTabMapSettings,
        showStopNumber: true
    },
    [constants.mapRouteModes.DISPATCHED]: {
        ...defaultPerTabMapSettings,
        showDriverActualLines: true,
        showStopNumber: true,
        showStopPopup: true
    },
    [constants.mapRouteModes.COMPLETED]: {
        ...defaultPerTabMapSettings,
        showDriverActualLines: true,
        showStopNumber: true,
        showStopPopup: true
    }
};

export const defaultGlobalMapSettings: MapSettingsState = {
    activeEquipmentClusterId: -1,
    hasIsolatedRoutes: false,
    isClusteringToggleEnabled: true,
    isMultipleCardSelectEnabled: false,
    mapMarkerMode: constants.mapMarkerModes.ROUTES,
    mapRouteMode: constants.mapRouteModes.EMPTY,
    redirectedToMapPage: false,
    shouldFitPlanMapToBounds: false,
    showTrafficLayer: false,
    viewCardDetails: false,
    ...perTabMapSettings
};

export const stateObjectKeyMap = {
    showZonePolygons: 'showZonePolygons',
    isZonePolygonsEditMode: 'isZonePolygonsEditMode'
} as const;
